interface RecoveryFlags {
  retry_settings?: Record<string, unknown> | null;
  ob_decline_recovery?: number | boolean | null;
  retry_with_apm?: number | boolean | null;
}

export interface ResultOfPay extends RecoveryFlags {
  transaction?: RecoveryFlags | null;
}

export const isRecoveryResult = (
  resultOfPay: ResultOfPay | null | undefined,
  isAmountFirstLayout: boolean,
): boolean => {
  if (!resultOfPay) return false;

  const transaction = resultOfPay.transaction || {};
  const retrySettings = isAmountFirstLayout
    ? transaction.retry_settings || resultOfPay.retry_settings
    : resultOfPay.retry_settings;

  return (
    Object.keys(retrySettings || {}).length > 0 ||
    !!(resultOfPay.ob_decline_recovery || transaction.ob_decline_recovery) ||
    !!(resultOfPay.retry_with_apm || transaction.retry_with_apm)
  );
};
